/** @type {import('../types').ProgramConfig} */
export default {
  code: 'MDF',
  displayName: 'Marketing Development Fund',
  shortName: 'MDF',
  color: 'green',
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [],
  listColumns: [],

  // Reviewer-feedback panel + validation-summary card. `key` values match the
  // snake_case step keys the MDF agent writes into state (step_N_*), which flow
  // through to detailed_validations. Ordered to mirror the SOP's Cash Claim
  // step sequence (see mdf_sop.yaml `steps:`).
  feedback: {
    enabled: true,
    validations: [
      { key: 'step_0_zero_claim_screen',
        label: '0. Zero-Claim Screen ($0 claim must be a Combo Cash Credit request)',
        keywords: ['zero claim', 'step_0', 'step 0'] },
      { key: 'step_1_claim_amount_positive',
        label: '1. Claim Amount Positive',
        keywords: ['claim amount', 'step_1', 'step 1'] },
      { key: 'step_2_po_4j_approval',
        label: '2. 4J PO India Approval (AWS India approver for 4J POs)',
        keywords: ['4j', 'po', 'approval', 'step_2', 'step 2'] },
      { key: 'step_3_invoice_present',
        label: '3. Third-Party Invoice Present',
        keywords: ['invoice present', 'invoice', 'step_3', 'step 3'] },
      { key: 'step_4_entity_linkage',
        label: '4. Invoice Entity Linkage (name/address matches FR invoice entity)',
        keywords: ['entity', 'linkage', 'name', 'address', 'step_4', 'step 4'] },
      { key: 'step_5_cost_share',
        label: '5. Cost Share (claim <= 50% of invoice total)',
        keywords: ['cost share', 'step_5', 'step 5'] },
      { key: 'step_6_line_item_eligibility',
        label: '6. Line-Item Eligibility (no ineligible / travel expenses)',
        keywords: ['line item', 'eligibility', 'travel', 'step_6', 'step 6'] },
      { key: 'step_7_duplicate_invoice',
        label: '7. Duplicate-Invoice Check (not used on a prior actioned claim)',
        keywords: ['duplicate', 'step_7', 'step 7'] },
      { key: 'step_8_sponsorship_eligibility',
        label: '8. Sponsorship Eligibility (event not on the NOT-ALLOW list)',
        keywords: ['sponsorship', 'event', 'step_8', 'step 8'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
